import { ReactNode, useEffect } from 'react'
import { getEnv } from 'helpers/common'
import { ymClosure } from 'utils/yandexMetrika'

interface IProps {
  children?: ReactNode
}

const VITE_REACT_APP_YM_LK_CODE = getEnv('VITE_REACT_APP_YM_LK_CODE')

export const YandexMetrikaProvider = function YandexMetrikaProvider({ children }: IProps) {
  useEffect(() => {
    const ym = window?.ym ?? ymClosure

    if (!VITE_REACT_APP_YM_LK_CODE) {
      // eslint-disable-next-line no-console
      console.log('%c[YandexMetrikaDev](INIT)', 'color: orange')

      return
    }

    ym(VITE_REACT_APP_YM_LK_CODE, 'init', { webvisor: true })
  }, [])

  return <>{children}</>
}
